import { Box, Button, Card, Container, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { MyAppBar } from "../appbar/MyAppBar";
import { MyFooter } from "../footer/MyFooter";

import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import { generatePath, Link, Redirect } from "react-router-dom";
import { appPath, paramName } from "../../router/AppRoute";
import { useAppSelector } from "../../app/hooks";
import { colorUtil } from "../../util/ColorUtil";
import { useTranslation } from 'react-i18next';
import DATA_QA from "../../util/DataQaAttr";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    container: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    couponImageDiv: {
      height: '75vw',
      width: '75vw',
      minWidth: '75vw',
      paddingTop: '100%',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    bottomBox: {
      height: '10vh',
    },
    titleCoupon: {
      fontSize: '32px',
      fontWeight: 'bold',
      padding: '26px 38px',
      lineHeight: '24px',
      "@media screen and (max-width: 560px)": {
        padding: '26px 25px',
      }
    },
    titleImage: {
      fontSize: '18px',
      fontWeight: 'bold',
    },
    subTitleImage: {
      fontSize: '15px',
      fontWeight: 'normal',
      overflowWrap: 'break-word',
      width: '100%',
    },
  });
});

export function CouponIntro(props: {
}): JSX.Element {
  const { t } = useTranslation();
  const coupon = useAppSelector((state) => {
    return state.inputAnswer.session.cxHttpRes?.data?.cxShopToken?.cxCoupon;
  })
  const isCommonQR = useAppSelector(
    (state): boolean =>
      !!state.inputAnswer.session.cxHttpRes?.data?.cxAppSession.shopqr?.token
        ?.isCommon
  );
  const classes = useStyles();

  const pathToNext = isCommonQR
    ? appPath.shopqr.inputBranch
    : generatePath(appPath.shopqr.inputAnswer, {
      [paramName.surveyQestionPageIndexStr]: 0,
    });

  if (!coupon) {
    return <Redirect to={pathToNext} />
  }

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      className={classes.container}
    >

      <MyAppBar />
      <Box position="relative" flexGrow="1">

        {/* 冒頭メッセージ begin */}
        <Box mt={4} display="none">
          <Typography variant="h5" align="center">
            <Box fontWeight="fontWeightBold">{t('question.here_today_coupon')}</Box>
          </Typography>
        </Box>
        {/* 冒頭メッセージ end */}

        {/* チャレンジメッセージ begin */}
        <Box mt={4} mx={3}>
          <Typography variant="h5" align="center">
            <Box
              fontWeight="fontWeightBold"
              style={{ wordBreak: 'break-word' }}
            >
              {coupon.topMessage}
            </Box>
          </Typography>
        </Box>
        {/* チャレンジメッセージ end */}

        {/* クーポン画像エリア begin */}
        <Box display="flex" justifyContent="center" mt={4}>
          <Card>
            <Box m={4} position="relative">

              {/* クーポン画像 begin */}
              <Box
                position="relative"
                className={classes.couponImageDiv}
                style={{
                  backgroundImage: `url(${coupon.psImageUrl})`,
                }}
              >
                {/* fade container begin */}
                <Box
                  position="absolute"
                  left={0}
                  top={0}
                  width="100%"
                  height="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor={colorUtil.black4}
                >
                  {/* 「クーポン見本」container begin */}
                  <Box
                    borderRadius="100px"
                    bgcolor={colorUtil.couponSample}
                  >
                    {/* 「クーポン見本」 begin */}
                    <Typography className={classes.titleCoupon}>
                      {t('question.sample_coupon')}
                    </Typography>
                    {/* 「クーポン見本」 end */}
                  </Box>
                  {/* 「見本 クーポン」container end */}
                </Box>
                {/* fade container end */}

                {/* Copyガード begin */}
                <Box
                  position="absolute"
                  left={0}
                  top={0}
                  width="100%"
                  height="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  &nbsp;
                </Box>
                {/* Copyガード end */}
              </Box>
              {/* クーポン画像 end */}
            </Box>
          </Card>
        </Box>
        {/* クーポン画像エリア end */}

        {/* 注意事項 begin */}
        <Box
          id='coupon-caution'
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "pre-line",
            width: "100%",
            px: 3,
            pt: 7,
            mb: 2,
          }}
        >
          <Typography variant='h6' className={classes.titleImage}>
            {t('question.terms_and_conditions')}
          </Typography>
          <Typography variant='subtitle1' className={classes.subTitleImage}>
            {coupon.caution}
          </Typography>
        </Box>
        {/* 注意事項 end */}

        {/* 回答するButton begin */}
        <Box display="flex" justifyContent="center" mt={4}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<TrendingUpIcon />}
            component={Link}
            to={pathToNext}
            data-qa={DATA_QA.BUTTON.START_ANSWER}
          >
            {t('question.btn.answer')}
          </Button>
        </Box>
        {/* 回答するButton end */}

        {/* 最下部余白 begin */}
        <Box className={classes.bottomBox}>&nbsp;</Box>
        {/* 最下部余白 end */}
      </Box>
      <MyFooter />

    </Container>
  )
}
